/* eslint-disable */
export default {
  infoMessageMins: '{delayTime} 分钟后自动保存日志...',
  infoMessageMin: '{delayTime} 分钟后自动保存日志...',
  infoMessageSecs: '{delayTime} 秒钟后自动保存日志...',
  infoMessageSec: '{delayTime} 秒钟后自动保存日志...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
